import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  Domain,
  AddDomainRequest,
  EditDomainRequest,
} from "./domains.interface";

@Injectable({
  providedIn: "root",
})
export class DomainsService {
  constructor(private httpClient: HttpClient) {}

  public fetchDomains(): Observable<Domain[]> {
    return this.httpClient.get<Domain[]>("/domains");
  }

  public addDomain(request: AddDomainRequest): Observable<unknown> {
    return this.httpClient.post("/domains", request);
  }

  public updateDomain(
    domain: string,
    request: EditDomainRequest,
  ): Observable<unknown> {
    return this.httpClient.put(
      `/domains/${encodeURIComponent(domain)}`,
      request,
    );
  }
}
